import { fromQueryString } from '@openphone/lib/fromQueryString'
import toQueryString from '@openphone/lib/toQueryString'
import cx from 'classnames'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import AnimatingLogo from '@src/app/components/AnimatingLogo'
import { PROTOCOL_QUO_DESKTOP } from '@src/app/url/URLRouter/CustomProtocolHandler'
import Button from '@ui/Button/Button'
import Typography from '@ui/Typography'
import { themeClassNames } from '@ui/theme'

import * as styles from './NativeLogin.css'
import { redirectGoogleLogin } from './google-login'

function NativeLogin() {
  const location = useLocation()
  const [params, setParams] = useState<Record<string, string> | null>(null)

  const [searchParams, setSearchParams] = useState<{
    [key: string]: string
  } | null>(null)

  useEffect(() => {
    // used by universal login
    const searchParams = fromQueryString(location.search)
    if (searchParams.code && searchParams.state) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- UXP-3732 - Fix React Compiler errors
      setSearchParams(searchParams)
      // eslint-disable-next-line react-hooks/immutability -- TODO: Avoid mutating values expected to be immutable (UXF-1123)
      redirectToUniversalLogin(searchParams)
      return
    }

    const params = fromQueryString(location.hash)
    if (params?.access_token) {
      setParams(params)
      // eslint-disable-next-line react-hooks/immutability -- TODO: Avoid mutating values expected to be immutable (UXF-1123)
      redirectToApp(params)
    } else {
      redirectGoogleLogin()
    }
  }, [location.hash, location.search])

  const redirectToUniversalLogin = (result: { [key: string]: string }) => {
    window.location.replace(
      `${PROTOCOL_QUO_DESKTOP}://auth/authorize${toQueryString(result)}`,
    )
  }

  const redirectToApp = (result: Record<string, string> | null) => {
    window.location.replace(`${PROTOCOL_QUO_DESKTOP}://login${toQueryString(result)}`)
  }

  const isRedirecting = !params || !searchParams

  return (
    <div
      className={cx(themeClassNames.light, styles.root, {
        [styles.redirect]: isRedirecting,
      })}
    >
      {(params || searchParams) && (
        <>
          <AnimatingLogo className={cx({ [styles.redirectingLogo]: isRedirecting })} />
          <Typography
            component="p"
            style={{ marginTop: 30 }}
            variant="bodyParagraph"
            color="textTertiary"
          >
            Redirecting you to the desktop app...
          </Typography>
          <Button
            style={{ marginTop: 10 }}
            variant="ghost"
            color="primary"
            onClick={() =>
              searchParams
                ? redirectToUniversalLogin(searchParams)
                : redirectToApp(params)
            }
          >
            Click here if it's taking too long
          </Button>
        </>
      )}
    </div>
  )
}

export default NativeLogin
